module.exports = __webpack_public_path__ + "static/media/car-trip.a6e2de96.png";